import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Platform, View, StyleSheet , Text,SafeAreaView, ScrollView, FlatList, Button, Image,StatusBar, TouchableOpacity } from 'react-native';
import { useTailwind } from 'tailwind-rn';
import { useNavigation } from '@react-navigation/native';



const Footer = (  ) => {

    const tailwind = useTailwind();
    const navigation = useNavigation();

    let GoHome = (object) => {
        console.log("Volver a recursos:");

        navigation.navigate("Principal", {  });
    }

    return (
        <View style={ tailwind("bg-gray-100 bg-pt-5 flex-row flex-wrap justify-evenly border-t-8 border-t-matcongreen p-4 pt-6") }>
            <Image
                source={require('../assets/images/footer/fcfm.png')}
                style={ tailwind("h-24 w-44 bottom-1 mx-4") }
                />
            <Image
                source={require('../assets/images/footer/cmmedu.png')}
                style={ tailwind("h-24 w-52 bottom-1 mx-4") }
                />
            <Image
                source={require('../assets/images/footer/unesco.png')}
                style={ tailwind("h-24 w-52 bottom-1 mx-4") }
                />
            <Image
                source={require('../assets/images/footer/mineduc.png')}
                style={ tailwind("h-24 w-28 bottom-1 mx-4") }
                />
            <Image
                source={require('../assets/images/footer/seamoscomunidad.png')}
                style={ tailwind("h-24 w-24 bottom-1 mx-4") }
                />
        </View>
    );

}

export default Footer